// gtag.js 얇은 어댑터 — window 를 만지는 유일한 곳. 전부 try/catch: 계측이 앱을 깨뜨리면 안 된다.
export type GtagAdapter = {
  ensureStub(): void
  setDisabled(on: boolean): void
  isDisabled(): boolean
  load(onLoaded: () => void, onError: () => void, timeoutMs?: number): void
  isLoaded(): boolean
  push(...args: unknown[]): void
}

export function createGtag(measurementId: string): GtagAdapter {
  let loaded = false
  let loadRequested = false
  const disableKey = `ga-disable-${measurementId}`
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = (): any => (typeof window !== 'undefined' ? window : null)

  return {
    ensureStub() {
      try {
        const win = w()
        if (!win || !measurementId) return
        win.dataLayer = win.dataLayer || []
        if (typeof win.gtag !== 'function') {
          // gtag.js 는 배열이 아닌 arguments 객체를 기대한다 (공식 스니펫과 동일)
          // eslint-disable-next-line prefer-rest-params
          win.gtag = function () {
            // eslint-disable-next-line prefer-rest-params
            win.dataLayer.push(arguments)
          }
        }
        // 부팅 시 선차단 — 초기화 명령이 push 된 직후에만 core 가 해제한다 (설계 §9.2)
        if (win[disableKey] === undefined) win[disableKey] = true
      } catch (e) {
        /* noop */
      }
    },
    setDisabled(on: boolean) {
      try {
        const win = w()
        if (win && measurementId) win[disableKey] = on
      } catch (e) {
        /* noop */
      }
    },
    isDisabled() {
      try {
        const win = w()
        return !win || !measurementId || win[disableKey] !== false
      } catch (e) {
        return true
      }
    },
    load(onLoaded, onError, timeoutMs = 10000) {
      try {
        const win = w()
        if (!win || !measurementId || loadRequested) return
        loadRequested = true
        const s = document.createElement('script')
        s.async = true
        s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`
        let done = false
        const timer = setTimeout(() => {
          if (done) return
          done = true
          onError()
        }, timeoutMs)
        s.onload = () => {
          if (done) return
          done = true
          clearTimeout(timer)
          loaded = true
          onLoaded()
        }
        // 광고차단 등으로 로드 실패 — 앱에는 영향 없음
        s.onerror = () => {
          if (done) return
          done = true
          clearTimeout(timer)
          onError()
        }
        document.head.appendChild(s)
      } catch (e) {
        try {
          onError()
        } catch (err) {
          /* noop */
        }
      }
    },
    isLoaded() {
      return loaded
    },
    push(...args: unknown[]) {
      try {
        const win = w()
        if (win && typeof win.gtag === 'function') win.gtag(...args)
      } catch (e) {
        /* noop */
      }
    },
  }
}
